import { useAtom } from 'jotai'
import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { videoElementAtom } from './atoms'
import { Play } from '@styled-icons/fluentui-system-filled/Play'
import { Pause } from '@styled-icons/fluentui-system-filled/Pause'

//* =========================== React Component  ===============================

/**
 * A play/pause button, which plays and pauses the video element, provided by
 * the videoElementAtom atom.
 */
const PlayPauseButton = (): JSX.Element => {
  const [isPaused, setPaused] = useState(true)
  const [videoElement] = useAtom(videoElementAtom)

  useEffect(() => {
    if (!videoElement) {
      return
    }

    videoElement.addEventListener('play', () => {
      setPaused(false)
    })

    videoElement.addEventListener('pause', () => {
      setPaused(true)
    })
  }, [videoElement])

  const onClick = (): void => {
    videoElement?.paused ? videoElement?.play() : videoElement?.pause()
  }

  return <Wrapper onClick={onClick}>{isPaused ? <Play /> : <Pause />}</Wrapper>
}

export default PlayPauseButton

//* =========================== Styled Components  =============================

const Wrapper = styled.div`
  pointer-events: auto;
  cursor: pointer;
  user-select: none;
  color: white;
  height: 100%;
  width: 100%;
`
